import NiceModal, { useModal } from '@ebay/nice-modal-react'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Icon from '../icon'

export interface HiddenPromos {
  expiryDate: string
  promoIds: string[]
}

interface PromotionsTermsModalProps {
  htmlContent: string
  promoId: string
}

const PromotionsTermsModal = ({
  htmlContent,
  promoId,
}: PromotionsTermsModalProps) => {
  const modal = useModal()
  const { t } = useTranslation('walletManagement')
  const [checked, setChecked] = useState(false)

  const toggle = () => {
    setChecked(prev => {
      const hiddenPromosString = localStorage.getItem('hiddenPromos')
      if (hiddenPromosString) {
        const hiddenPromos: HiddenPromos = JSON.parse(hiddenPromosString)
        const isExpired =
          new Date(hiddenPromos.expiryDate).getDay() !== new Date().getDay()
        if (isExpired) {
          localStorage.setItem(
            'hiddenPromos',
            JSON.stringify({
              expiryDate: new Date(),
              promoIds: [promoId],
            }),
          )
        } else {
          localStorage.setItem(
            'hiddenPromos',
            JSON.stringify({
              expiryDate: hiddenPromos.expiryDate,
              promoIds: prev
                ? hiddenPromos.promoIds.filter(item => item !== promoId)
                : [...hiddenPromos.promoIds, promoId],
            }),
          )
        }
      } else {
        localStorage.setItem(
          'hiddenPromos',
          JSON.stringify({
            expiryDate: new Date(),
            promoIds: [promoId],
          }),
        )
      }

      return prev ? false : true
    })
  }

  useEffect(() => {
    if (!modal.visible) return
    // Check if already checked
    const hiddenPromosString = localStorage.getItem('hiddenPromos')
    if (hiddenPromosString) {
      const hiddenPromos: HiddenPromos = JSON.parse(hiddenPromosString)
      const isExpired = dayjs().diff(dayjs(hiddenPromos.expiryDate), 'days') > 1
      if (isExpired) return
      setChecked(hiddenPromos.promoIds.includes(promoId))
    }
  }, [modal.visible])

  return (
    <Modal
      id="promotion-terms-modal"
      containerStyle="!w-[calc(100%-30px)] lg:max-w-[600px]"
      zIndex={206}>
      <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        className="common-scrollbar article-content w-[calc(100%+9px)] max-h-[calc(100vh-300px)] bg-primary text-txt mb-3 overflow-x-hidden overflow-y-auto dark:[&::-webkit-scrollbar-thumb]:bg-tertiary"
      />
      <div className="flx-str-ctr" onClick={toggle}>
        <div className="flx-ctr w-5 h-5 rounded-full border-[1.5px] border-[#999] -mt-0.5">
          {checked && (
            <Icon id="check" width={15} height={15} className="stroke-[#999]" />
          )}
        </div>
        <p className="text-sm lg:text-base text-[#999] font-Avenir-Light ml-2">
          {t('dont-show')}
        </p>
      </div>
      <div className="flx-ctr mt-4 lg:mt-6">
        <button
          onClick={() => closeModal(modal)}
          className={classNames(
            'w-[120px] lg:w-[170px] text-lg lg:text-xl text-ok-btn-txt text-center font-Avenir-Light py-[7px] lg:py-2.5 bg-ok-btn-bg',
            'border-[1.5px] border-ok-btn-bg rounded-[22px] lg:rounded-[26px] transition-all duration-200 ease-in-out',
          )}>
          Ok
        </button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(PromotionsTermsModal)
